<div id="map" class="map" [class.public]="isPublic" leaflet [leafletOptions]="mapOptions" [leafletLayers]="layers"
    (leafletMapReady)="onMapReady($event)">
</div>